<template>
  <section class="page-container">
    <span class="sub-heading">Investigating {{$store.state.currentGame.location.name}}</span>
    <div class="investigate-card"
      v-for="clue in clues"
      :key="clue.name"
      v-html="clue.details">
    </div>
    <div class="icon-row">
      <icon-buttons back="back" />
    </div>
  </section>
</template>
<style lang="scss">
.investigate-card > p {
  text-align: justify;
}
</style>
<script>
import IconButtons from '@/components/IconButtons.vue';
import htmlRenderer from '../../lib/cmsRichTextHtmlRenderer';

export default {
  components: {
    IconButtons,
  },
  data() {
    return {
      clues: [],
    };
  },
  mounted() {
    this.clues = this.$store.state.currentGame.location.clues;
    this.clues.forEach((c) => {
      if (typeof c.details !== 'string') {
        // eslint-disable-next-line no-param-reassign
        c.details = htmlRenderer(c.details);
      }
      if (this.$store.state.currentGame.discoveredClues.findIndex(d => d.name === c.name) === -1) {
        this.$store.commit('addDiscoveredClue', c);
      }
    });
  },
};
</script>
